export enum matomeListTypes {
  FETCH_MATOME_LIST_REQUEST = "FETCH_MATOME_LIST_REQUEST",
  FETCH_MATOME_LIST_SUCCESS = "FETCH_MATOME_LIST_SUCCESS",
  FETCH_MATOME_LIST_FAILURE = "FETCH_MATOME_LIST_FAILURE",
}